export const CLOSE_RIGHT_PANE = 'CLOSE_RIGHT_PANE';
export const OPEN_RIGHT_PANE = 'OPEN_RIGHT_PANE';

export const SWITCH_REPORT_TABS = 'SWITCH_REPORT_TABS';
export const SWITCH_SIDE_NAV_ITEMS = 'SWITCH_SIDE_NAV_ITEMS';

export const REDIRECT_TO_LOGIN = 'REDIRECT_TO_LOGIN';

export const FETCH_FEATURE_FLAG_SUCCESS = 'FETCH_FEATURE_FLAG_SUCCESS';
